import util from '@/libs/util';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink, concat } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import Vue from 'vue';
import VueApollo from 'vue-apollo';

Vue.use(VueApollo);

const httpLink = new HttpLink({
  uri: '/gapi/gql/api'
});

const authMiddleware = new ApolloLink((operation, forward) => {
  const token = util.cookies.get('token');
  console.log('token:'+ token);
  operation.setContext({
    headers: {
      Authorization: `Bearer ${token}`,
      access_token : token,
    },
    errorHandler(error) {
      console.log('全局错误拦截');
      console.error(error);
    },
  });
  return forward(operation);
});

const apolloClient = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache: new InMemoryCache(),
  connectToDevTools: true,

});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  // defaultOptions: {
  //   $loadingKey: 'loading'
  // },
  errorHandler(error) {
    console.log('全局错误拦截');
    console.error(error);
  },
});

export default apolloProvider;
